import { TranslationKeyPrefix, useTranslations } from 'hooks/useTranslations'

export function usePageTitle(translationPrefix: TranslationKeyPrefix) {
  const { getTranslationLiteral: tl } = useTranslations(TranslationKeyPrefix.AccountCreation)
  const { getTranslationLiteral: tlPageTitle } = useTranslations(translationPrefix)

  return `${tlPageTitle('page_title')} | ${tl('christies')}`
}
